import React from 'react';
import PropTypes from 'prop-types';

const TicketItem = ({ driver, number, eta, counter }) => (
  <li>
    <span className="ticket-driver">{driver}</span>
    <span className="ticket-number">CG/NF: {number}</span>
    <span className="ticket-meta">
      {eta && <span className="ticket-eta">Previsão: {eta}</span>}
      {counter && <span className="ticket-counter">{counter}</span>}
    </span>
  </li>
);


TicketItem.propTypes = {
  driver: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  eta: PropTypes.string,
  counter: PropTypes.string
};

export default React.memo(TicketItem);
